import { useSelector } from 'react-redux';
import React from 'react';
import { elementPropertyRulesSelectors } from '@fullstory/redux';
import { flattenElementPropertyRules } from '../utils';
import { useElementPropertyRules } from './useElementPropertyRules';

const { getElementPropertyRulesById } = elementPropertyRulesSelectors;

export const useElementPropertyRulesTable = () => {
  const { loading, allElementPropertyRules } = useElementPropertyRules();
  const elementPropertyRulesById = useSelector(getElementPropertyRulesById);
  const flattenedElementPropertyRules = React.useMemo(
    () => flattenElementPropertyRules(allElementPropertyRules),
    [allElementPropertyRules],
  );

  return {
    loading,
    flattenedElementPropertyRules,
    elementPropertyRulesById,
  };
};
